import styled, { css } from "styled-components";
import { device } from "./components/Layout/mediaQuery";

export const btnStyle = css`
  color: ${(props) => props.theme.colorsPalette.primaryColor};
  border: 1px solid ${(props) => props.theme.colorsPalette.primaryColor};
  background: transparent;
  display: inline-block;
  cursor: pointer;
  font-weight: 400;
  letter-spacing: 4px;
  text-decoration: none;
  font-family: "Helvetica Neue";
  padding: 10px 18px;
  border-radius: 4px;
  text-align: center;
  text-transform: uppercase;
  animation: fadeIn 1s 1.8s backwards;
  transition: background 0.3s ease-out;

  &:hover {
    background: ${(props) => props.theme.colorsPalette.primaryColor};
    color: #333;
  }
`;

export const TextZone = styled.div`
  display: flex;
  flex-direction: column;
  width: 45%;
  @media ${device.tablet} {
    width: 50%;
  }
  @media ${device.landscapeMobile} {
    width: 100%;
  }
`;
export const HeadingText = styled.h1`
  font-size: 53px;
  font-family: "Coolvetica";
  font-weight: 400;
  margin: 0;
  position: relative;
  white-space: nowrap;

  &::before,
  &::after {
    color: ${(props) => props.theme.colorsPalette.primaryColor};
    font-family: "La Belle Aurore";
    font-size: 18px;
    position: absolute;
    line-height: 18px;
    opacity: 0.6;
  }

  &::before {
    content: "<h1>";
  }
  &::after {
    content: "</h1>";

    animation: fadeIn 1s 1.7s backwards;
  }
  @media ${device.tablet} {
    font-size: 40px;
  }
  @media ${device.mobile} {
    font-size: 30px;
  }
  @media ${device.landscapeMobile} {
    margin-top: 10%;
  }
`;

export const SubHeading = styled.h2`
  color: #8d8d8d;
  margin-top: 20px;
  font-weight: 400;
  font-size: 14px;
  font-family: "Coolvetica";
  letter-spacing: 3px;
  animation: fadeIn 1s 2.5s backwards;
`;
